import React from 'react';
import { Avatar as ChakraAvatar } from '@chakra-ui/react';

const ReusableAvatar = ({
  mb,
  name,
  size = 'lg',
  mr = 4,
  bg = 'linear-gradient(134.23deg, #071D54 14.41%, #1E3A8A 85.58%)',
  color = 'white',
  src,
}) => {
  return (
    <ChakraAvatar
      name={name}
      size={size}
      mr={mr}
      mb={mb}
      bg={src ? undefined : bg}
      color={color}
      src={src}
    />
  );
};

export default ReusableAvatar;
